import { useEffect, useState } from 'react'

import {
  traceService,
  type ObservabilityAnalysisProvider,
} from '../services/traceService'

export function useAIAnalysisModels(provider: ObservabilityAnalysisProvider) {
  const [models, setModels] = useState<string[]>([])
  const [defaultModel, setDefaultModel] = useState('')
  const [loadingModels, setLoadingModels] = useState(false)
  const [modelsError, setModelsError] = useState('')
  const [resolvedProvider, setResolvedProvider] = useState<ObservabilityAnalysisProvider>('auto')

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      setLoadingModels(true)
      setModelsError('')
      setModels([])
      setDefaultModel('')
      setResolvedProvider(provider)
      try {
        const response = await traceService.getObservabilityAnalysisModels(provider)
        if (cancelled) return
        const catalog = response.data
        setModels(catalog.models || [])
        setDefaultModel(catalog.defaultModel || '')
        setResolvedProvider(catalog.provider)
      } catch (error) {
        if (cancelled) return
        setModels([])
        setDefaultModel('')
        setResolvedProvider(provider)
        setModelsError(error instanceof Error ? error.message : 'No se pudo cargar el catalogo de modelos')
      } finally {
        if (!cancelled) setLoadingModels(false)
      }
    }

    void load()
    return () => {
      cancelled = true
    }
  }, [provider])

  return {
    models,
    defaultModel,
    loadingModels,
    modelsError,
    resolvedProvider,
  }
}
